export default [
    {
    path: '/register/phoneRegister',
    name: 'phoneRegister',
    meta: {
      index: 2
    },
    component: () => import('@/views/register/phoneRegister')
  }
  ]
  